import React from 'react'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import {
    formataTableCellHeadExibeDadosTitulo,
    formataTableCellHeadExibeDadosTexto,
    formataTableCellHeadExibeDadosValor,
    formataTableCellHeadExibeDadosTextoQuebraEspecial,
    formataTableCellHeadExibeDadosValorQuebraEspecial,
    formataTableCellBodyExibeDadosTitulo,
    formataTableCellBodyExibeDadosTexto,
    formataTableCellBodyExibeDadosValor,
} from '../../../business-components/Formata/Formata'

import {
    pesquisaList,
} from '../../../business-rules/List/ListService'

import {
    DivFormEstudo,
} from '../../../business-components/Div/Div'

import {
    CardGridDivBody,
} from '../../../business-components/Card/Card'

import {
    TableExibeDados,
    TableHeadExibeDados,
    TableRowHeadExibeDados,
    TableBodyExibeDados,
    TableRowBodyExibeDados,
    TableCellBodyExibeDados,
} from '../../../business-components/Table/TableExibeDados'

import familiaresList from '../../../business-rules/List/familiaresList'



const EstudoReportConferenciaDadosClienteConjuge = ( { values, report } ) => {

    const ConferenciaDadosClienteConjuge = () => {

        const aumentoLetraCabecalho = 1
        const aumentoLetraReportCabecalho = 1
        
        const aumentoLetra = 2
        const aumentoLetraReport = values.disposicaoRelatorio === HARDCODE.disposicaoRelatorioRetrato ? 2 : 1
            
        let headList = [
            {
                colSpan: 4,
                headTitle: formataTableCellHeadExibeDadosTitulo(LABEL.nomeCurto, report, null, aumentoLetraCabecalho,
                    aumentoLetraReportCabecalho, values),
            },
            {
                colSpan: 2,
                headTitle: formataTableCellHeadExibeDadosTexto(LABEL.idade, report, aumentoLetraCabecalho,
                    aumentoLetraReportCabecalho, values),
            },
            {
                colSpan: 3,
                headTitle: formataTableCellHeadExibeDadosTextoQuebraEspecial(LABEL.idadeVaiAposentarQuebraEspecial, report,
                    aumentoLetraCabecalho, aumentoLetraReportCabecalho, values),
            },
            {
                colSpan: 3,
                headTitle: formataTableCellHeadExibeDadosTextoQuebraEspecial(LABEL.idadeExpectativaVidaQuebraEspecial, report,
                    aumentoLetraCabecalho, aumentoLetraReportCabecalho, values),
            },
            {
                colSpan: 3,
                headTitle: formataTableCellHeadExibeDadosTextoQuebraEspecial(LABEL.idadeDataSimulacaoQuebraEspecial, report,
                    aumentoLetraCabecalho, aumentoLetraReportCabecalho, values),
            },
        ]

        let colSpan = 0

        if (values.exibirMorteAte) {
            
            headList.push(
                {
                    colSpan: 3,
                    headTitle: formataTableCellHeadExibeDadosValorQuebraEspecial(LABEL.idadeSimulacaoMorteQuebraEspecial, report,
                        aumentoLetraCabecalho, aumentoLetraReportCabecalho, values),
                },
            )

            colSpan = 1
        }

        if (values.tabClienteFormList !== LABEL.tabClienteFormListPrevidenciaPrivada) {

            headList.push(
                {
                    colSpan: 4,
                    headTitle: formataTableCellHeadExibeDadosValor(LABEL.receitaMensal, report, aumentoLetraCabecalho,
                        aumentoLetraReportCabecalho, values),
                },
                {
                    colSpan: 5,
                    headTitle: formataTableCellHeadExibeDadosValor(LABEL.percResp, report, aumentoLetraCabecalho,
                        aumentoLetraReportCabecalho, values),
                },
                /*
                {
                    colSpan: 3,
                    headTitle: formataTableCellHeadExibeDadosTexto(LABEL.tipoIR, report, aumentoLetraCabecalho,
                        aumentoLetraReportCabecalho, values),
                },
                */
            )
        }

        return (
            <DivFormEstudo>
                <CardGridDivBody>
                    <TableExibeDados
                        report={report}
                        noMinW={true} // tratamento para não ter diferenciação do tamanho de letra no relatório
                    >
                        <TableHeadExibeDados
                            report={report}
                        >
                            <TableRowHeadExibeDados
                                dados={headList}
                            />
                        </TableHeadExibeDados>
    
                        <TableBodyExibeDados>
                            {familiaresList(values)?.map((item, ind) => {
                                return item.id <= HARDCODE.idFamiliarConjuge &&
                                !pesquisaList(values.exclusaoFamiliares, item.id).id ? (
                                //item.id <=
                                //(pesquisaList(values.exclusaoFamiliares, HARDCODE.idFamiliarConjuge).id ? HARDCODE.idFamiliarCliente : HARDCODE.idFamiliarConjuge) ? (
                                    <TableRowBodyExibeDados
                                        key={ind}
                                        report={report}
                                    >
                                        <TableCellBodyExibeDados
                                            colSpan={headList[0].colSpan}
                                            primeiraColuna={true}
                                        >
                                            {formataTableCellBodyExibeDadosTitulo(item.descricao, report, null, null,
                                                aumentoLetra, aumentoLetraReport, values)}
                                        </TableCellBodyExibeDados>
                                        
                                        <TableCellBodyExibeDados
                                            colSpan={headList[1].colSpan}
                                        >
                                            {formataTableCellBodyExibeDadosTexto(item.idade, report, false,
                                                aumentoLetra, aumentoLetraReport, values)}
                                        </TableCellBodyExibeDados>
                                        
                                        <TableCellBodyExibeDados
                                            colSpan={headList[2].colSpan}
                                        >
                                            {formataTableCellBodyExibeDadosTexto(item.idadeVaiAposentar,
                                                report, false, aumentoLetra, aumentoLetraReport, values)}
                                        </TableCellBodyExibeDados>
                                        
                                        <TableCellBodyExibeDados
                                            colSpan={headList[3].colSpan}
                                        >
                                            {formataTableCellBodyExibeDadosTexto(item.idadeExpectativaVida,
                                                report, false, aumentoLetra, aumentoLetraReport, values)}
                                        </TableCellBodyExibeDados>
    
                                        <TableCellBodyExibeDados
                                            colSpan={headList[4].colSpan}
                                        >
                                            {formataTableCellBodyExibeDadosTexto(item.idadeDataSimulacao,
                                                report, false, aumentoLetra, aumentoLetraReport, values)}
                                        </TableCellBodyExibeDados>
    
                                        {values.exibirMorteAte && (
                                            <TableCellBodyExibeDados
                                                colSpan={headList[5].colSpan}
                                            >
                                                {formataTableCellBodyExibeDadosTexto(item.idadeSimulacaoMorte,
                                                    report, false, aumentoLetra, aumentoLetraReport, values)}
                                            </TableCellBodyExibeDados>
                                        )}
    
                                        {values.tabClienteFormList !== LABEL.tabClienteFormListPrevidenciaPrivada && (
                                            <>
                                                <TableCellBodyExibeDados
                                                    colSpan={headList[5 + colSpan].colSpan}
                                                >
                                                    {formataTableCellBodyExibeDadosValor(item.receitaMensal,
                                                        report, false, false, aumentoLetra, aumentoLetraReport, values)}
                                                </TableCellBodyExibeDados>
                                                
                                                <TableCellBodyExibeDados
                                                    colSpan={headList[6 + colSpan].colSpan}
                                                >
                                                    {formataTableCellBodyExibeDadosValor(item.percResp, report,
                                                        false, true, aumentoLetra, aumentoLetraReport, values)}
                                                </TableCellBodyExibeDados>
                                                
                                                {/*
                                                <TableCellBodyExibeDados
                                                    colSpan={headList[7 + colSpan].colSpan}
                                                >
                                                    {formataTableCellBodyExibeDadosTitulo(item.tipoIRDescricao, report)}
                                                </TableCellBodyExibeDados>
                                                */}
                                            </>
                                        )}
                                    </TableRowBodyExibeDados>
                                )
                                :
                                (
                                    <TableRowBodyExibeDados
                                        key={ind}
                                        report={report}
                                    />
                                )
                            })}
                        </TableBodyExibeDados>
                    </TableExibeDados>
                </CardGridDivBody>
            </DivFormEstudo>
        )
    }



    return (
        <ConferenciaDadosClienteConjuge/>
    )
}

export default EstudoReportConferenciaDadosClienteConjuge